import {AuthenticationService} from './../../services/authentication.service';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from '../../services/template.service';
import {Chart} from 'chart.js';
import * as _ from 'lodash';
import {ApiService} from '../../services/api.service';
import {SubSink} from 'subsink';
import {HttpParams} from '@angular/common/http';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';

@Component({
  selector: 'app-email-dashboard',
  templateUrl: './email-dashboard.component.html',
  styleUrls: ['./email-dashboard.component.scss'],
  providers: [TemplateService]
})
export class EmailDashboardComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  modal: NgbModalRef;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  transactions_success;
  transactions_failed;
  transactions_not_sent;
  transactions_manually_sent;
  successChart: Chart;
  failedChart: Chart;
  notSentChart: Chart;
  manuallySentChart: Chart;
  selectedValues = [];
  emailTotal;
  data;
  keepstartDate: any = null;
  keependDate: any = null;
  allZipCount: number;
  allZipCurrent = 0;

  company;
  treeTableValue;
  docType;
  myChart1;
  myChart2;
  myChart3;
  myChart4;
  canDownloadXml: boolean = false;

  loading = false;
  datastatus: any;
  selectedBuyerTaxId = null;
  selectedDocumentId = null;
  selectedStatus = null;
  buyerTaxId: any;
  documentId: any;
  buyerTaxIdList = [];
  documentIdList = [];
  allBuyerTaxIdList = [];
  allDocumentIdList = [];
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  documentType: any;
  allDocumentType: any;
  tableData: any;
  email: any;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  loading_all_zip_progress = 0;
  tableArray = [];

  selectedCompany: string;
  companyList: any;

  sortBy: string;
  sortMode: string;

  countOther = 0;
  countNonOther = 0;

  tableCol = [
    {field: 'tax_data__document_number', header: 'เลขที่เอกสาร'},
    {field: 'tax_data__header_issue_dt', header: 'วันที่ออกเอกสาร'},
    {field: 'created_at', header: 'วันที่ส่งอีเมลล์'},
    {field: 'tax_data__buyer_name', header: 'ชื่อผู้ซื้อ'},
    {field: 'tax_data__reference_ref_location', header: 'Location'},
    {field: 'tax_data__rd_document_type', header: 'ประเภทเอกสาร'},
    {field: 'status', header: 'สถานะ'},
    {field: 'receiver_email', header: 'อีเมลผู้รับ'},
  ];

  constructor(private apiService: ApiService,
              private template: TemplateService,
              private authService: AuthenticationService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.generateChart();
    this.loadTexts();
    this.rdDocumentType = this.template.getDropdown();
  }

  generateChart() {
    const totalChart = this.transactions_success + this.transactions_failed + this.transactions_not_sent + this.transactions_manually_sent;
    this.successChart = new Chart('successChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Success Chart',
          data: [this.transactions_success, totalChart - this.transactions_success],
          backgroundColor: [
            '#30e9e9',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed'
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
    this.failedChart = new Chart('failedChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Failed Chart',
          data: [this.transactions_failed, totalChart - this.transactions_failed],
          backgroundColor: [
            '#ff1f1a',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed'
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
    this.notSentChart = new Chart('notSentChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Not Sent Chart',
          data: [this.transactions_not_sent, totalChart - this.transactions_not_sent],
          backgroundColor: [
            '#FFCD56',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed'
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
    this.manuallySentChart = new Chart('manuallySentChart', {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: 'Manually Sent Chart',
            data: [this.transactions_manually_sent, totalChart - this.transactions_manually_sent],
            backgroundColor: [
              '#ab72c0',
              '#6F6E6E'
            ],
            borderColor: [
              '#ededed',
              '#ededed'
            ],
            borderWidth: 1
          }
        ]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });

  }

  pageChanged() {
    this.loadData();
    this.canDownloadXml = false;
  }

  changeEmailReportStatus(taxDataArray, status) {
    let params = new HttpParams();
    params = params.append('tax_data_id_array', taxDataArray);
    params = params.append('status', status);
    this.apiService.updateEmailReportStatus(params).subscribe(() => {
      this.loadTexts();
      this.loadData();
    });
  }

  changeEmailSelectedReportStatus() {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i] || this.datastatus[i].status === 'success' || this.datastatus[i].status === 'manually_sent') {
        continue;
      }
      this.tableArray.push(this.datastatus[i].tax_data);
    }
    if (!_.isEmpty(this.tableArray)) {
      this.changeEmailReportStatus(this.tableArray, 'manually_sent');
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  searchButtonClicked() {
    this.loadData(true);
  }

  clearData() {
    this.clearField();
    this.loadTexts();
  }

  clearField() {
    this.transactions_failed = null;
    this.transactions_manually_sent = null;
    this.transactions_not_sent = null;
    this.transactions_success = null;
    this.datastatus = null;
    this.startDate = null;
    this.selectedBuyerTaxId = null;
    this.selectedDocumentId = null;
    this.selectedStatus = null;
    this.currentPage = 1;
    this.buyerTaxId = null;
    this.documentId = null;
    this.buyerTaxIdList = [];
    this.documentIdList = [];
    this.allBuyerTaxIdList = [];
    this.allDocumentIdList = [];
    this.startDate = null;
    this.endDate = null;
    this.totalItems = 0;
    this.emailTotal = 0;
    this.sortBy = null;
    this.sortMode = null;
    this.canDownloadXml = false;
    this.selectedValues = [];
  }

  loadData(is_search = false) {
    this.datastatus = [];
    this.selectedValues = [];
    this.loading = true;
    let params = new HttpParams();
    if (this.selectedBuyerTaxId) {
      params = params.append('buyer_tax_id', this.selectedBuyerTaxId);
    }
    if (this.selectedDocumentId) {
      params = params.append('document_number', this.selectedDocumentId);
    }
    if (this.selectedRdDocumentType) {
      params = params.append('document_type', this.selectedRdDocumentType);
    }
    if (this.selectedStatus) {
      params = params.append('status', this.selectedStatus);
    }
    if (this.startDate) {
      this.keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
      params = params.append('document_date_start', this.keepstartDate);
    }
    if (this.endDate) {
      this.keependDate = moment(this.endDate).format('YYYY-MM-DD');
      params = params.append('document_date_end', this.keependDate);
    }
    if (this.sortBy) {
      params = params.append('ordering', this.sortBy);
    }
    params = params.append('seller_tax_id', this.selectedCompany);
    params = params.append('page', _.toString(this.currentPage));
    params = params.append('page_size', _.toString(this.itemsPerPage));
    this.apiService.getEmailDashboard(params).subscribe(
      (result) => {
        this.datastatus = result.results;
        this.totalItems = result.count;
        this.transactions_failed = result.transactions_failed;
        this.transactions_success = result.transactions_success;
        this.transactions_not_sent = result.transactions_not_sent;
        this.transactions_manually_sent = result.transactions_manually_sent;
        this.emailTotal = this.transactions_success + this.transactions_failed
          + this.transactions_not_sent + this.transactions_manually_sent;
        if (is_search === true) {
          this.generateChart();
        }
        this.loading = false;
        this.sniff('GET_EMAIL_DASHBOARD', '');
      });
  }

  getEmailDashboard() {
    let params = new HttpParams();
    if (this.selectedCompany) {
      params = params.append('seller_tax_id', this.selectedCompany);
    }
    this.apiService.getEmailDashboard(params).subscribe(
      (result) => {
        this.transactions_success = result.transactions_success;
        this.transactions_failed = result.transactions_failed;
        this.transactions_not_sent = result.transactions_not_sent;
        this.transactions_manually_sent = result.transactions_manually_sent;
        this.emailTotal = this.transactions_success + this.transactions_failed
          + this.transactions_not_sent + this.transactions_manually_sent;
        this.generateChart();
        _.forEach(result.results, (obj) => {
          this.buyerTaxId.push({
            label: obj.buyer_tax_id,
            value: obj.buyer_tax_id
          });
          this.buyerTaxIdList.push({
            label: obj.buyer_tax_id,
            value: obj.buyer_tax_id
          });
          this.documentId.push({
            label: obj.document_number,
            value: obj.document_number
          });
          this.documentIdList.push({
            label: obj.document_number,
            value: obj.document_number
          });
        });
        this.sniff('GET_EMAIL_DASHBOARD', '');
      }, error => error(status));
  }

  loadTexts() {
    this.selectedBuyerTaxId = null;
    this.selectedDocumentId = null;
    this.buyerTaxId = null;
    this.documentId = null;
    this.selectedRdDocumentType = null;
    this.buyerTaxId = [{
      label: 'ทั้งหมด',
      value: null
    }];
    this.documentId = [{
      label: 'ทั้งหมด',
      value: null
    }];
    this.companyList = [{
      label: 'ทั้งหมด',
      value: ''
    }];

    this.selectedCompany = '';
    this.apiService.getCompany().subscribe((results) => {
      _.forEach(results, obj => {
        this.companyList.push({
          label: obj.name,
          value: obj.tax_id
        });
      });
      if (this.companyList.length === 2) {
        this.selectedCompany = this.companyList[1].value;
        this.companyList.splice(0, 1);
      } else {
        this.selectedCompany = this.companyList[0].value;
      }
      this.getEmailDashboard();
    });
  }

  filterDocumentIdList() {
    // this.selectedDocumentId = null;
    this.documentIdList = [{
      label: 'ทั้งหมด',
      value: null
    }];

    _.forEach(this.allDocumentIdList, (obj) => {
      if (this.selectedDocumentId == null || obj.value === this.selectedDocumentId) {
        this.documentIdList.push({
          label: obj.label,
          value: obj.value
        });
      }
    });
  }

  filterBuyerTaxIdList() {
    // this.selectedBuyerTaxId = null;
    this.buyerTaxIdList = [{
      label: 'ทั้งหมด',
      value: null
    }];

    _.forEach(this.allBuyerTaxIdList, (obj) => {
      if (this.selectedBuyerTaxId == null || obj.value == this.selectedBuyerTaxId) {
        this.buyerTaxIdList.push({
          label: obj.label,
          value: obj.value
        });
      }
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  selectedType(type, status) {
    if (this.selectedStatus === status) {
      this.selectedStatus = null;
    } else {
      this.selectedStatus = status;
    }
    this.currentPage = 1;
    this.loadData();
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  selectIn(checker, data) {
    if (data.document_type !== 'other' && checker === true) {
      this.canDownloadXml = this.selectedValues.filter(select => select === true).length > 0;
      this.countNonOther++;

      if (this.countNonOther > 0) {
        this.canDownloadXml = true;
      }
    }
    if (data.document_type !== 'other' && checker === false) {
      this.canDownloadXml = (data.document_type !== 'other' && this.selectedValues.filter(select => select === true).length !== 0);
      this.countNonOther--;
      if (this.countNonOther === 0) {
        this.canDownloadXml = false;
      }
    }
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  selectAll() {
    for (let i = 0; i < this.datastatus.length; i++) {
      if (this.datastatus[i].doc_status === 'active' && this.datastatus[i].status !== 'success') {
        this.canDownloadXml = this.selectedValues[i] = true;
      }
    }
    this.countOther = 0;
    this.countNonOther = 0;
    this.datastatus.forEach(obj => {
      if (obj.document_type === 'other') {
        this.countOther++;
      } else {
        this.countNonOther++;
      }
    });

  }

  deselectAll() {
    for (let i = 0; i < this.datastatus.length; i++) {
      this.canDownloadXml = this.selectedValues[i] = false;
    }
    this.countOther = 0;
    this.countNonOther = 0;

  }

  DownloadSelected(content, doc_type) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i] || this.datastatus[i].doc_status === 'cancelled') {
        continue;
      }
      // skip if rd_document_type is `other`
      if (this.datastatus[i].document_type === 'other' && doc_type === 'xml') {
        continue;
      }
      this.tableArray.push(this.datastatus[i]);
    }
    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;

      if (doc_type === 'xml') {
        this.download(0, this.tableArray, 'xml_file');
      } else {
        this.download(0, this.tableArray, 'pdf_file');
      }
    }
  }

  download(index, tableArray, url_field_name) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message =
        'Download เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const download_url = tableArray[index][url_field_name];

    // skip if download url is empty.
    if (download_url == null || download_url.length === 0) {
      this.download(index + 1, tableArray, url_field_name);
      return;
    }

    this.subs.add(
      this.apiService.downloadFileFromMediaPath(download_url).subscribe(
        obj => {
          if (this.cancel_loading_all_zip) {
            return;
          }

          // this.loading_all_zip = false;
          let filename = this.getFileName(tableArray[index]);

          if (url_field_name === 'xml_file') {
            filename = filename + '.xml';
          } else {
            filename = filename + '.pdf';
          }

          this.apiService.createDownloadFile(obj, filename);
          this.allZipCurrent++;
          this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
          // data.xmlLoading = false;
          setTimeout(() => {
            this.download(index + 1, tableArray, url_field_name);
          }, 1000);
        },
        error => {
          this.loading_all_zip = false;
          this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
          // data.xmlLoading = false;
        }
      )
    );
  }

  getFileName(data) {
    let file_name =
      '' + data.document_number + '_' + data.document_type + '_' + data.document_date;
    file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
    return file_name;
  }

  sort(event) {
    if (event.order === '1') {
      this.sortBy = event.field;
      this.sortMode = 'asc';
    } else {
      this.sortBy = '-' + event.field;
      this.sortMode = 'desc';
    }
  }

  canDownloadPdf() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  isExist(data) {
    return data != null && data !== '' && data !== '' && data !== undefined;
  }

  createDownloadFile(blob, filename) {
    // for IE10+
    if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const element = document.createElement('a');
      document.body.appendChild(element);

      const url = window.URL.createObjectURL(blob);
      element.setAttribute('href', url);
      element.setAttribute('download', filename);

      element.style.display = 'none';
      element.click();

      document.body.removeChild(element);
    }
  }

  downloadExcel() {
    this.selectedValues = [];
    let params = new HttpParams();
    if (this.selectedBuyerTaxId) {
      params = params.append('buyer_tax_id', this.selectedBuyerTaxId);
    }
    if (this.selectedDocumentId) {
      params = params.append('document_number', this.selectedDocumentId);
    }
    if (this.selectedRdDocumentType) {
      params = params.append('document_type', this.selectedRdDocumentType);
    }
    if (this.selectedStatus) {
      params = params.append('status', this.selectedStatus);
    }
    if (this.startDate) {
      this.keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
      params = params.append('document_date_start', this.keepstartDate);
    }
    if (this.endDate) {
      this.keependDate = moment(this.endDate).format('YYYY-MM-DD');
      params = params.append('document_date_end', this.keependDate);
    }
    if (this.sortBy) {
      params = params.append('ordering', this.sortBy);
    }
    params = params.append('page', _.toString(this.currentPage));
    params = params.append('page_size', _.toString(this.itemsPerPage));
    this.apiService.getExcelEmailDashboard(params).subscribe(
      result => {
        const filename = 'Email_Dashboard.xlsx';
        this.createDownloadFile(result, filename);
        this.sniff('DOWNLOAD_EXCEL', filename);
      }
    );
  }

  isViewerAudit() {
    return this.authService.isViewerAudit();
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'EMAIL_DASHBOARD',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }

}



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts